// import { Users } from '@just-in-types';
import store from "..";
import { firestore } from "../../firebase";

export const enum CheckInsActionTypes {
  GET_DAILY_CHECKINS = "checkIns.GET_DAILY_CHECKINS",
  GET_DAILY_CHECKINS_SUBSCRIPTION = "checkIns.GET_DAILY_CHECKINS_SUBSCRIPTION"
}

interface WatchDailyCheckInsAction {
  payload: string;
  type: CheckInsActionTypes.GET_DAILY_CHECKINS;
}
interface WatchDailyCheckInsSubscriptionAction {
  payload: null | (() => void);
  type: CheckInsActionTypes.GET_DAILY_CHECKINS_SUBSCRIPTION;
}

export type CheckInsAction =
  | WatchDailyCheckInsAction
  | WatchDailyCheckInsSubscriptionAction;

const checkInsRef = firestore.collection("checkIns");

export const watchDailyCheckIns = async (
  siteId: string | null,
  businessId: string | null
) => {
  store.dispatch({
    payload: "...",
    type: CheckInsActionTypes.GET_DAILY_CHECKINS
  });


  if (businessId) {
    const now = new Date();
    const lastMidnight = now.setHours(0, 0, 0, 0);
    console.log(lastMidnight);

    // then convert those to UTC0 to pass on in your query to firestore
    // const lastMidNightUTC = new Date(lastMidnight + now.getTimezoneOffset() * 60000).toString();
    const today = new Date();
    let dd: any = today.getDate();
    let mm: any = today.getMonth() + 1;
    const yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }

    if (mm < 10) {
      mm = "0" + mm;
    }
    const date = mm + "-" + dd + "-" + yyyy;

    if (siteId && siteId !== "all") {
      const query = firestore
        .collection("checkIns")
        .where("businessId", "==", businessId)
        .where("siteId", "==", siteId)
        .where("timestamp", ">=", new Date(date))
        .onSnapshot(snap => {
          const size = snap.size;
          store.dispatch({
            payload: size.toString(),
            type: CheckInsActionTypes.GET_DAILY_CHECKINS
          });
        });
      store.dispatch({
        payload: query,
        type: CheckInsActionTypes.GET_DAILY_CHECKINS_SUBSCRIPTION
      });
    } else if (siteId === "all") {
      console.log("finding size...");
      const query = firestore
        .collection("checkIns")
        .where("businessId", "==", businessId)
        .where("timestamp", ">=", new Date(date))
        .onSnapshot(snap => {
          const size = snap.size;
          console.log(snap.size);
          store.dispatch({
            payload: size.toString(),
            type: CheckInsActionTypes.GET_DAILY_CHECKINS
          });
        });
      store.dispatch({
        payload: query,
        type: CheckInsActionTypes.GET_DAILY_CHECKINS_SUBSCRIPTION
      });
    }

    // const unsubscribe = firestore
    //   .collection('counters')
    //   .doc(businessId)
    //   .onSnapshot(
    //     snap => {
    //       if (siteId && siteId !== 'all') {
    //         const counters = snap.get(siteId);

    //         if (counters) {
    //           store.dispatch<WatchDailyCheckInsAction>({
    //             payload: counters.length.toString(),
    //             type: CheckInsActionTypes.GET_DAILY_CHECKINS,
    //           });
    //         } else {
    //           store.dispatch<WatchDailyCheckInsAction>({
    //             payload: '0',
    //             type: CheckInsActionTypes.GET_DAILY_CHECKINS,
    //           });
    //         }
    //       } else if (siteId === 'all') {
    //         const counters: Users.CheckInCounter[] = [];
    //         const siteData = snap.data();

    //         // we have to manually do this loop because firestore has no ability to query arrays of objects
    //         if (siteData) {
    //           for (const site in siteData) {
    //             if (site) {
    //               counters.push(...snap.get(site));
    //             }
    //           }
    //         }

    //         if (counters) {
    //           store.dispatch<WatchDailyCheckInsAction>({
    //             payload: counters.length.toString(),
    //             type: CheckInsActionTypes.GET_DAILY_CHECKINS,
    //           });
    //         }
    //       }
    //     },
    //     error => {
    //       console.error(error);
    //     },
    //   );

    // store.dispatch<WatchDailyCheckInsSubscriptionAction>({
    //   payload: unsubscribe,
    //   type: CheckInsActionTypes.GET_DAILY_CHECKINS_SUBSCRIPTION,
    // });
  }
};

export const updateCheckIn = ({
  checkInId,
  update
}: {
  checkInId: string;
  update: { [field: string]: any };
}) =>
  checkInsRef
    .doc(checkInId)
    .update(update)
    .catch(error => console.error(error));



// WEBPACK FOOTER //
// ./src/store/actions/checkInsActions.ts